export default "__VITE_ASSET__B9uo6Bsc__"